import React from "react";
import { getPairDisplay, getPairMeta } from "../pairMeta";
import { ReactComponent as CloseIcon } from "@assets/images/icons/close-dropdown.svg";

/**
 * One favorite pair: switches to it on click, × removes it from favorites.
 *
 * @param {object} props
 * @param {object} props.pair
 * @param {(pair: object) => void} props.onSelect
 * @param {(slug: string) => void} props.onRemove
 */
export const FavoritePairShortcut = ({ pair, onSelect, onRemove }) => {
  const meta = getPairMeta(pair.slug);
  const { title } = getPairDisplay(pair);

  return (
    <div className="futures-quote__recent">
      <button
        type="button"
        className="futures-quote__recent-btn"
        title={title}
        aria-label={title}
        onClick={() => onSelect(pair)}
      >
        <span className="futures-quote__recent-inner">
          {meta?.icon ? (
            <img src={meta.icon} alt="" />
          ) : (
            <span>{pair.slug.slice(0, 1)}</span>
          )}
        </span>
      </button>

      <button
        type="button"
        className="futures-quote__recent-remove"
        aria-label={`Remove ${title} from favorites`}
        onClick={() => onRemove(pair.slug)}
      >
        <CloseIcon />
      </button>
    </div>
  );
};
